import React from 'react';

const Footer = () => {
    return (
        <footer className="footer">
            <div className="footer-top">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-lg-9 col-md-6">
                            <div className="footer-widget footer-about">
                                <div className="footer-about-content">
                                    <p> A complete solution for clinics and hospitals. </p>
                                    <div className="social-icon">
                                        <ul>
                                            <li>
                                                <a href="#" target="_blank"><i className="fab fa-facebook-f"></i> </a>
                                            </li>
                                            <li>
                                                <a href="#" target="_blank"><i className="fab fa-twitter"></i> </a>
                                            </li>
                                            <li>
                                                <a href="#" target="_blank"><i className="fab fa-linkedin-in"></i></a>
                                            </li>
                                            <li>
                                                <a href="#" target="_blank"><i className="fab fa-instagram"></i></a>
                                            </li>
                                            <li>
                                                <a href="#" target="_blank"><i className="fab fa-dribbble"></i> </a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>

                        </div>

                     
                        <div className="col-lg-3 col-md-6">

                            <div className="footer-widget footer-contact">
                                <h2 className="footer-title">Contact Us</h2>
                                <div className="footer-contact-info">
                                    <div className="footer-address">
                                        <span><i className="fas fa-map-marker-alt"></i></span>
                                        <p> Nuremberg <br /> Germany </p>
                                    </div>
                                    <p>
                                        <i className="fas fa-phone-alt"></i>
                                        +49 1515 87387
                                            </p>
                                    <p className="mb-0">
                                        <i className="fas fa-envelope"></i>
                                        info@accepire.com
                                            </p>
                                </div>
                            </div>

                        </div>

                    </div>
                </div>
            </div>

            <div className="footer-bottom">
                <div className="container-fluid">

                    <div className="copyright">
                        <div className="row">
                            <div className="col-md-6 col-lg-6">
                                <div className="copyright-text">
                                    <p className="mb-0">Copyright &copy; 2020 <a href="https://www.accepire.com">Accepire</a>. All rights reserved.</p>
                                </div>
                            </div>
                            <div className="col-md-6 col-lg-6">

                                <div className="copyright-menu">
                                    <ul className="policy-menu">
                                        <li><a href="">Terms and Conditions</a></li>
                                        <li><a href="">Policy</a></li>
                                    </ul>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    );
};


export default Footer;